import type { ApiMethod } from '@/services/api.service';
import type { FileVersion } from '@/store/file.interface';

export enum ProcessorType {
  Multer = 1,
  Formidable = 2,
}

export interface SavingOptions {
  data?: unknown | null;
  image?: string | null;
  version: FileVersion;
}

export interface UploadingOptions {
  data?: unknown | null;
  image?: string | null;
  method: ApiMethod;
  processorType: ProcessorType;
  url: string;
}
